// External libraries
import styled from '@emotion/styled';

const InfoButton = styled.button`
  background-color: transparent;
  border: none;
  margin-right: 15px;
  margin-top: 5px;
  outline: 0;
  padding: 0;

  &:focus {
    border-style: none;
    box-shadow: none;
  }
`;

const EmailAndTooltipContainer = styled.div`
  position: relative;
`;

export { EmailAndTooltipContainer, InfoButton };
